<template>
  <!-- partial -->
  <div class="page-content">
    <div class="row">
      <div class="col-lg-8 col-md-8 col-sm-6 col-xs-12">
        <h5 class="txt-dark">
          <back-button link="/rest-hours-management/crew-details"></back-button>
          Update Crew Details
        </h5>
      </div>
      <!-- Breadcrumb -->
      <div class="col-lg-4 col-sm-6 col-md-4 col-xs-12">
        <ol class="breadcrumb breadcrumb-line" style="float: right">
          <li class="breadcrumb-item">
            <router-link :to="`/`">Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">Rest Hours Management</li>
          <li class="breadcrumb-item">
            <router-link :to="`/rest-hours-management/crew-details`"
              >Crew Details</router-link
            >
          </li>
          <li class="breadcrumb-item active" aria-current="page">Update</li>
        </ol>
      </div>
    </div>
    <!-- /Breadcrumb -->
    <!-- Form  -->
    <div class="row">
      <div class="col-md-12 grid-margin stretch-card">
        <div class="card">
          <div class="card-body">
            <ul class="nav nav-tabs" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="general-tab"
                  data-bs-toggle="tab"
                  href="#general"
                  role="tab"
                  aria-controls="general"
                  aria-selected="true"
                  >General Data</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="signing-status-tab"
                  data-bs-toggle="tab"
                  href="#signing-status"
                  role="tab"
                  aria-controls="signing-status"
                  aria-selected="false"
                  >Signing Status</a
                >
              </li>
            </ul>
            <div class="tab-content border border-top-0 p-3" id="myTabContent">
              <!-- For General Sectiion -->
              <div
                class="tab-pane fade show active"
                id="general"
                role="tabpanel"
                aria-labelledby="general-tab"
              >
                <h4>
                  <i class="link-arrow" data-feather="edit"></i> General details
                </h4>
                <hr />
                <div class="row">
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Employee Code</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.employee_code"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Employee Code"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <div class="form-check form-switch mb-2">
                          <input
                            type="checkbox"
                            v-model="form.is_drinking"
                            class="form-check-input"
                            id="formSwitch1"
                          />
                        </div>
                        <label class="col-form-label">Drinking</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <div class="form-check form-switch mb-2">
                          <input
                            type="checkbox"
                            v-model="form.is_smoking"
                            class="form-check-input"
                            id="formSwitch1"
                          />
                        </div>
                        <label class="col-form-label">Smoking</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Full Name</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          readonly
                          v-model="full_name"
                          class="form-control"
                          placeholder="Full Name"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Given Name</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.given_name"
                          class="form-control"
                          placeholder="Given Name"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Surname</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.surname"
                          class="form-control"
                          placeholder="Surname"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Father Name</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.father_name"
                          class="form-control"
                          placeholder="Father Name"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Pool Code</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.pool_code_id"
                          :suggestions="pool_codes"
                          placeholder="Select Pool Code"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Location</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.location_id"
                          :suggestions="locations"
                          placeholder="Select Location"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Ship Manager</label
                      >
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.ship_manager_id"
                          :suggestions="ship_managers"
                          placeholder="Select Ship Manager"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Department</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.department_id"
                          :suggestions="departments"
                          placeholder="Select Department"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Employee Role</label
                      >
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.employee_role_id"
                          :suggestions="employee_roles"
                          placeholder="Select Employee Role"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Crew Type</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.crew_type_id"
                          :suggestions="crew_types"
                          placeholder="Select Crew Type"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-1">
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <div class="form-check form-switch mb-2">
                          <input
                            type="checkbox"
                            v-model="form.is_signed_on"
                            class="form-check-input"
                            id="formSwitch1"
                          />
                        </div>
                        <label class="col-form-label">Signed ON</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <div class="form-check form-switch mb-2">
                          <input
                            type="checkbox"
                            v-model="form.is_has_contract"
                            class="form-check-input"
                            id="formSwitch1"
                          />
                        </div>
                        <label class="col-form-label">Has Contract</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <div class="form-check form-switch mb-2">
                          <input
                            type="checkbox"
                            v-model="form.is_balcklisted"
                            class="form-check-input"
                            id="formSwitch1"
                          />
                        </div>
                        <label class="col-form-label">Blacklisted</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="row mb-3">
                      <div class="col-sm-4">
                        <div class="form-check form-switch mb-2">
                          <input
                            type="checkbox"
                            v-model="form.is_resigned"
                            class="form-check-input"
                            id="formSwitch1"
                          />
                        </div>
                        <label class="col-form-label">Resigned</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-1">
                    <div class="row mb-3">
                      <div class="col-sm-6">
                        <div class="form-check form-switch mb-2">
                          <input
                            type="checkbox"
                            v-model="form.is_not_recommended_re_contract"
                            class="form-check-input"
                            id="formSwitch1"
                          />
                        </div>
                        <label class="col-form-label"
                          >Not recommended for re-contract</label
                        >
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Comment</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.comment"
                          class="form-control"
                          placeholder="Comment"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label">Attachment</label>
                      <div class="col-sm-9">
                        <input
                          type="file"
                          name="attachment"
                          ref="file"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Attachment"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row mb-2">
                      <label class="col-sm-3 col-form-label">Image Path</label>
                      <div class="col-sm-9">
                        <input
                          type="file"
                          name="imagepath"
                          ref="file"
                          class="form-control"
                          autocomplete="off"
                          placeholder="Image Path"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Created By</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          readonly
                          v-model="form.created_by_id"
                          class="form-control"
                          placeholder="Created By"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Created On</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          readonly
                          v-model="form.created_on"
                          class="form-control"
                          placeholder="Created On"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <h4>
                  <i class="link-arrow" data-feather="edit"></i> Personal
                  details
                </h4>
                <hr />
                <div class="row">
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Gender</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.gender"
                          :suggestions="genders"
                          placeholder="Select Gender"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Marital Status</label
                      >
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.marital_status"
                          :suggestions="marital_statuses"
                          placeholder="Select Marital Status"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Nationality</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.nationality_id"
                          :suggestions="nationalities"
                          placeholder="Select Nationality"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Country</label>
                      <div class="col-sm-9">
                        <my-select
                          disableFormControl="true"
                          :selection.sync="form.country_id"
                          :suggestions="countries"
                          placeholder="Select Country"
                        ></my-select>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Date Of Birth</label
                      >
                      <div class="col-sm-9">
                        <my-datepicker
                          :date.sync="form.dob"
                          placeholder="Enter Date Of Birth"
                        ></my-datepicker>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Age</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          readonly
                          v-model="age"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Place of Birth</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.place_of_birth"
                          class="form-control"
                          placeholder="Place of Birth"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Phone Number</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.phone"
                          class="form-control"
                          placeholder="Phone Number"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Email</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.email"
                          class="form-control"
                          placeholder="Email"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Height (cm)</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.height"
                          class="form-control"
                          placeholder="Height (cm)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Weight (kg)</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.weight"
                          class="form-control"
                          placeholder="Weight (kg)"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >BMI (kg/m<sup>2</sup>)</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          readonly
                          v-model="form.bmi"
                          class="form-control"
                          placeholder="0.0"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-8">
                    <div class="row">
                      <div class="col-md-6">
                        <div class="row mb-3">
                          <label class="col-sm-3 col-form-label"
                            >Discharge Book Number</label
                          >
                          <div class="col-sm-9">
                            <input
                              type="text"
                              v-model="form.discharge_book_no"
                              class="form-control"
                              placeholder="Discharge Book Number"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row mb-3">
                          <label class="col-sm-3 col-form-label"
                            >Income Tax No</label
                          >
                          <div class="col-sm-9">
                            <input
                              type="text"
                              v-model="form.income_tax_no"
                              class="form-control"
                              placeholder="Income Tax No"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6">
                        <div class="row mb-3">
                          <label class="col-sm-3 col-form-label"
                            >EPF Number</label
                          >
                          <div class="col-sm-9">
                            <input
                              type="text"
                              readonly
                              v-model="form.epf_no"
                              class="form-control"
                              placeholder="EPF Number"
                            />
                          </div>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="row mb-3">
                          <label class="col-sm-3 col-form-label"
                            >NRIC number</label
                          >
                          <div class="col-sm-9">
                            <input
                              type="text"
                              readonly
                              v-model="form.nric_no"
                              class="form-control"
                              placeholder="NRIC number"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Qualification</label
                      >
                      <div class="col-sm-9">
                        <textarea
                          name="qualification"
                          class="form-control"
                          id=""
                          cols="5"
                          rows="5"
                          v-model="form.qualification"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">SOCSO No</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          readonly
                          v-model="form.socso_no"
                          class="form-control"
                          placeholder="SOCSO No"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Mobile Number</label
                      >
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.mobile_no"
                          class="form-control"
                          placeholder="Mobile Number"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Fax</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.fax"
                          class="form-control"
                          placeholder="Fax"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">City</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.city"
                          class="form-control"
                          placeholder="City"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-md-4">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label">Religion</label>
                      <div class="col-sm-9">
                        <input
                          type="text"
                          v-model="form.region"
                          class="form-control"
                          placeholder="Religion"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Present Address</label
                      >
                      <div class="col-sm-9">
                        <textarea
                          name="present_address"
                          class="form-control"
                          id=""
                          cols="5"
                          rows="5"
                          v-model="form.present_address"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >Home Address</label
                      >
                      <div class="col-sm-9">
                        <textarea
                          name="home_address"
                          class="form-control"
                          id=""
                          cols="5"
                          rows="5"
                          v-model="form.home_address"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="row mb-3">
                      <label class="col-sm-3 col-form-label"
                        >General Remarks</label
                      >
                      <div class="col-sm-9">
                        <textarea
                          name="general_remarks"
                          class="form-control"
                          id=""
                          cols="5"
                          rows="5"
                          v-model="form.general_remarks"
                        ></textarea>
                      </div>
                    </div>
                  </div>
                </div>
                <h4>
                  <i class="link-arrow" data-feather="edit"></i> Travel
                  Documents
                </h4>
                <hr />
                <div class="table-responsive">
                  <table id="dataTableExample" class="table table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Alert Type</th>
                        <th>Document Type</th>
                        <th>Document Number</th>
                        <th>Country</th>
                        <th>Issue Date</th>
                        <th>Expiry Date</th>
                        <th>Place Of Issue</th>
                        <th>Issued By</th>
                        <th>Active</th>
                        <th>Attachment</th>
                        <th class="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table
                        :isLoading="isLoading"
                        cols="14"
                      ></loading-table>
                      <tr v-if="form.crew_documents.length == 0">
                        <td colspan="14" class="text-center">No data Found</td>
                      </tr>
                      <tr
                        v-for="(crew_document, ar) in form.crew_documents"
                        :key="`crew_document${ar}`"
                      >
                        <td>{{ ar + 1 }}.</td>
                        <td></td>
                        <td>
                          <my-select
                            disableFormControl="true"
                            :selection.sync="crew_document.document_type_id"
                            :suggestions="document_types"
                            placeholder="Select Document Type"
                          ></my-select>
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Document No"
                            v-model="crew_document.document_no"
                          />
                        </td>
                        <td>
                          <my-select
                            disableFormControl="true"
                            :selection.sync="crew_document.country_id"
                            :suggestions="countries"
                            placeholder="Select Country"
                          ></my-select>
                        </td>
                        <td>
                          <my-datepicker
                            :date.sync="crew_document.issue_date"
                            placeholder="Enter Issue Date"
                          ></my-datepicker>
                        </td>
                        <td>
                          <my-datepicker
                            :date.sync="crew_document.expiry_date"
                            placeholder="Enter Expiry Date"
                          ></my-datepicker>
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Place Of Issue"
                            v-model="crew_document.place_of_issue"
                          />
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Issued By"
                            v-model="crew_document.issued_by"
                          />
                        </td>
                        <td>
                          <div class="form-check form-switch mb-2">
                            <input
                              type="checkbox"
                              v-model="crew_document.is_active"
                              class="form-check-input"
                              id="formSwitch1"
                            />
                          </div>
                        </td>
                        <td>
                          <input
                            type="file"
                            class="form-control"
                            name="doc_attachment"
                            ref="doc_attachment"
                          />
                        </td>
                        <td>
                          <div class="text-center">
                            <button
                              class="btn btn-danger btn-sm"
                              @click="deleteDocuments(crew_document)"
                              v-if="!crew_document.id"
                            >
                              Delete
                            </button>
                            <button
                              class="btn btn-danger btn-sm"
                              @click="delete_documents_data(crew_document.id)"
                              v-else
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="form.crew_documents">
                        <td
                          colspan="14"
                          align="center"
                          @click="addEmptyDocuments()"
                          style="
                            background-color: #6571ff;
                            color: white;
                            border-radius: 10px;
                            box-shadow: none;
                          "
                        >
                          Add New Row
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- /Table -->
                </div>
              </div>
              <!-- For Signing Status -->
              <div
                class="tab-pane fade"
                id="signing-status"
                role="tabpanel"
                aria-labelledby="signing-status-tab"
              >
                <div class="table-responsive">
                  <table id="dataTableExample" class="table table-hover">
                    <thead>
                      <tr>
                        <th>Sr. No.</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                        <th>Comments</th>
                        <th>Attachment</th>
                        <th>Signed to Vessel</th>
                        <th>Role</th>
                        <th>Acctual Sign on Date</th>
                        <th>Sign on Port</th>
                        <th>Expected Sign Off Date</th>
                        <th>Acctual Sign Off Date</th>
                        <th>Sign Off Port</th>
                        <th>Sign Off Reason</th>
                        <th class="text-center">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <loading-table
                        :isLoading="isLoading"
                        cols="14"
                      ></loading-table>
                      <tr v-if="form.crew_signing_statuses.length == 0">
                        <td colspan="14" class="text-center">No data Found</td>
                      </tr>
                      <tr
                        v-for="(
                          crew_signing_status, ar
                        ) in form.crew_signing_statuses"
                        :key="`crew_signing_status${ar}`"
                      >
                        <td>{{ ar + 1 }}.</td>
                        <td>
                          <my-datepicker
                            :date.sync="crew_signing_status.start_date"
                            placeholder="Enter Start Date"
                          ></my-datepicker>
                        </td>
                        <td>
                          <my-datepicker
                            :date.sync="crew_signing_status.end_date"
                            placeholder="Enter End Date"
                          ></my-datepicker>
                        </td>
                        <td>
                          <input
                            v-uppercase
                            type="text"
                            class="form-control"
                            placeholder="Comment"
                            v-model="crew_signing_status.comment"
                          />
                        </td>
                        <td>
                          <input
                            type="file"
                            class="form-control"
                            name="sign_status_attachment"
                            ref="sign_status_attachment"
                          />
                        </td>
                        <td>
                          <my-select
                            disableFormControl="true"
                            :selection.sync="
                              crew_signing_status.signed_vessel_id
                            "
                            :suggestions="vessels"
                            placeholder="Select Signed Vessel"
                          ></my-select>
                        </td>
                        <td>
                          <my-select
                            disableFormControl="true"
                            :selection.sync="crew_signing_status.role_id"
                            :suggestions="roles"
                            placeholder="Select role"
                          ></my-select>
                        </td>
                        <td>
                          <my-datepicker
                            :date.sync="crew_signing_status.actual_sign_on_date"
                            placeholder="Enter Actual Sign On Date"
                          ></my-datepicker>
                        </td>
                        <td>
                          <my-select
                            disableFormControl="true"
                            :selection.sync="crew_signing_status.sign_on_port"
                            :suggestions="signOnPorts"
                            placeholder="Select Sign On Port"
                          ></my-select>
                        </td>
                        <td>
                          <my-datepicker
                            :date.sync="
                              crew_signing_status.expected_sign_off_date
                            "
                            placeholder="Enter Expected Sign Off Date"
                          ></my-datepicker>
                        </td>
                        <td>
                          <my-datepicker
                            :date.sync="
                              crew_signing_status.actual_sign_off_date
                            "
                            placeholder="Enter Actual Sign Off Date"
                          ></my-datepicker>
                        </td>
                        <td>
                          <my-select
                            disableFormControl="true"
                            :selection.sync="crew_signing_status.sign_off_port"
                            :suggestions="signOffPorts"
                            placeholder="Select Sign Off Port"
                          ></my-select>
                        </td>
                        <td>
                          <my-select
                            disableFormControl="true"
                            :selection.sync="
                              crew_signing_status.sign_off_reason
                            "
                            :suggestions="signOffReasons"
                            placeholder="Select Sign Off Reason"
                          ></my-select>
                        </td>
                        <td>
                          <div class="text-center">
                            <button
                              class="btn btn-danger btn-sm"
                              @click="
                                deleteSigningStatuses(crew_signing_status)
                              "
                              v-if="!crew_signing_status.id"
                            >
                              Delete
                            </button>
                            <button
                              class="btn btn-danger btn-sm"
                              @click="
                                delete_signing_statuses_data(
                                  crew_signing_status.id
                                )
                              "
                              v-else
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                      <tr v-if="form.crew_signing_statuses">
                        <td
                          colspan="14"
                          align="center"
                          @click="addEmptySigningStatuses()"
                          style="
                            background-color: #6571ff;
                            color: white;
                            border-radius: 10px;
                            box-shadow: none;
                          "
                        >
                          Add New Row
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <!-- /Table -->
                </div>
              </div>
            </div>
            <br />
            <div class="form mb-0">
              <submit-button
                :isLoading="isLoading"
                @submit="update"
                text="Update"
                style="float: right"
              ></submit-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- partial -->
</template>

<script type="text/javascript">
import axios from "axios";
import moment from "moment";


export default {
  name: "CrewDetailUpdate",
  data() {
    return {
      form: {
        pool_code_id: "",
        location_id: "",
        ship_manager_id: "",
        department_id: "",
        employee_role_id: "",
        crew_type_id: "",
        gender: "",
        marital_status: "",
        nationality_id: "",
        country_id: "",
        crew_signing_statuses: [],
        crew_documents: [],
      },
      vessels: [],
      roles: [],
      genders: [],
      marital_statuses: [],
      crew_types: [],
      document_types: [],
      employee_roles: [],
      departments: [],
      ship_managers: [],
      locations: [],
      pool_codes: [],
      signOnPorts: [],
      signOffPorts: [],
      signOffReasons: [],
      countries: [],
      nationalities: [],
      isLoading: false,
    };
  },
  computed: {
    full_name() {
      return this.form.given_name + " " + this.form.surname;
    },
    age() {
      let DateOfBirth = moment(this.form.dob).isValid()
        ? moment(this.form.dob)
        : moment(this.form.dob, "DD-MM-YYYY").toDate();
      let current_date = moment();
      let duration = current_date.diff(DateOfBirth, "years");
      return duration;
    },
  },
  mounted() {
    this.getData();
    this.getMasters();
  },
  methods: {
    async getMasters() {
      let masters = await axios.get("crews/masters");
      masters = masters.data;
      masters.vessels.forEach((vessel) => {
        this.vessels.push({
          id: vessel.id,
          name: vessel.name,
        });
      });
      masters.employee_roles.forEach((employee_role) => {
        this.employee_roles.push({
          id: employee_role.id,
          name: employee_role.name,
        });
      });
      masters.countries.forEach((country) => {
        this.countries.push({
          id: country.id,
          name: country.name,
        });
      });
      masters.nationalities.forEach((nationality) => {
        this.nationalities.push({
          id: nationality.id,
          name: nationality.name,
        });
      });
      masters.ship_managers.forEach((ship_manager) => {
        this.ship_managers.push({
          id: ship_manager.id,
          name: ship_manager.name,
        });
      });
      masters.document_types.forEach((document_type) => {
        this.document_types.push({
          id: document_type.id,
          name: document_type.name,
        });
      });
      masters.genders.forEach((gender) => {
        this.genders.push({
          id: gender.id,
          name: gender.name,
        });
      });
      masters.marital_statuses.forEach((marital_status) => {
        this.marital_statuses.push({
          id: marital_status.id,
          name: marital_status.name,
        });
      });
      masters.crew_types.forEach((crew_type) => {
        this.crew_types.push({
          id: crew_type.id,
          name: crew_type.name,
        });
      });
      masters.departments.forEach((department) => {
        this.departments.push({
          id: department.id,
          name: department.name,
        });
      });
      masters.locations.forEach((location) => {
        this.locations.push({
          id: location.id,
          name: location.name,
        });
      });
      masters.pool_codes.forEach((pool_code) => {
        this.pool_codes.push({
          id: pool_code.id,
          name: pool_code.name,
        });
      });
      masters.sign_on_ports.forEach((sign_on_port) => {
        this.sign_on_ports.push({
          id: sign_on_port.id,
          name: sign_on_port.name,
        });
      });
      masters.sign_off_ports.forEach((sign_off_port) => {
        this.sign_off_ports.push({
          id: sign_off_port.id,
          name: sign_off_port.name,
        });
      });
      masters.sign_off_reasons.forEach((sign_off_reason) => {
        this.sign_off_reasons.push({
          id: sign_off_reason.id,
          name: sign_off_reason.name,
        });
      });
    },
    async getData() {
      this.isLoading = true;
      let form = await axios.get(`/crews/${this.$route.params.crew_Id}`);
      this.form = form.data.data;
      this.isLoading = false;
    },
    async update() {
      try {
        this.form.full_name = this.full_name;
        this.isLoading = true;
        await axios.post(`/crews`, this.form);
        this.isLoading = false;
        this.$router.push("/rest-hours-management/crew-details");
      } catch (e) {
        this.isLoading = false;
      }
    },
    deleteDocuments(document) {
      this.form.crew_documents = this.form.crew_documents.filter(
        (ar) => ar != document
      );
    },
    addEmptyDocuments() {
      this.form.crew_documents.push({
        company_id: this.company.id,
        document_type_id: "",
        document_no: "",
        country_id: "",
        issue_date: "",
        expiry_date: "",
        place_of_issue: "",
        issued_by: "",
        is_active: 1,
        attachment: "",
      });
    },
    async delete_documents_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=crew_documents`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
    deleteSigningStatuses(signing_status) {
      this.form.crew_signing_statuses = this.form.crew_signing_statuses.filter(
        (ar) => ar != signing_status
      );
    },
    addEmptySigningStatuses() {
      this.form.crew_signing_statuses.push({
        // supplier_detail_id: this.form.id,
        company_id: this.company.id,
        start_date: "",
        end_date: "",
        comment: "",
        attachment: "",
        signed_vessel_id: "",
        role_id: "",
        actual_sign_on_date: "",
        sign_on_port: "",
        expected_sign_off_date: "",
        actual_sign_off_date: "",
        sign_off_port: "",
        sign_off_reason: "",
      });
    },
    async delete_signing_statuses_data(id) {
      let check = confirm("Are you sure you want to delete the data");
      if (check) {
        try {
          this.isLoading = true;
          await axios.post(`delete?id=${id}&table_name=crew_signing_statuses`);
          this.isLoading = false;
          this.getData();
        } catch (e) {
          this.isLoading = false;
        }
      }
    },
  },
};
</script>
